import { defineStore } from 'pinia'
export default defineStore({
  id: 'costDataTable',
  persist: true,
  state: () => {
    return {
      isCostArchive: false,
      isGasolineArchive: false
    }
  },
  actions: {
    setIsCostArchive: function (payload: any) {
      this.isCostArchive = payload
    },
    setIsGasolineArchive: function (payload: any) {
      this.isGasolineArchive = payload
    }
  },
  getters: {
    getIsCostArchive: (state: any) => state.isCostArchive,
    getIsGasolineArchive: (state: any) => state.isGasolineArchive
  }
})
